import React__default from 'react';

const ConversationSkeleton = () => {
    return (React__default.createElement("div", { style: {
            width: "100%",
            maxWidth: "900px",
            display: "flex",
            flexDirection: "column",
            gap: "24px",
            padding: "20px 0",
        } },
        React__default.createElement("div", { style: {
                display: "flex",
                justifyContent: "flex-end",
                animation: "fadeIn 0.3s ease-in",
            } },
            React__default.createElement("div", { style: {
                    width: "60%",
                    height: "60px",
                    backgroundColor: "#e9ecef",
                    borderRadius: "18px",
                    borderBottomRightRadius: "5px",
                    animation: "pulse 1.5s ease-in-out infinite",
                } })),
        React__default.createElement("div", { style: {
                display: "flex",
                justifyContent: "flex-start",
                animation: "fadeIn 0.3s ease-in 0.2s both",
            } },
            React__default.createElement("div", { style: {
                    width: "80%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                } },
                React__default.createElement("div", { style: {
                        width: "100%",
                        height: "120px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "18px",
                        borderBottomLeftRadius: "5px",
                        animation: "pulse 1.5s ease-in-out infinite",
                    } }),
                React__default.createElement("div", { style: {
                        width: "70%",
                        height: "80px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "18px",
                        animation: "pulse 1.5s ease-in-out infinite",
                        animationDelay: "0.2s",
                    } }))),
        React__default.createElement("style", null, `
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
        `)));
};

export { ConversationSkeleton };
//# sourceMappingURL=ConversationSkeleton.js.map
